// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        /* Store Custom Code - Start */

        typographyProps: {
            color: "text.link",
            size: pxToRem(14),
            css: css`
                margin-right: ${pxToRem(4)};
                line-height: 27px;
            `,
        },
        css: css`
            padding: ${pxToRem(16)} 0;
            ${siteWidthStyles()}
            flex-wrap: wrap;
            color: ${getColor("text.main")};

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smallest};
            `}

            ${Slash} {
                line-height: "inherit";
            }

            a {
                ${linkStyles("inherit", "text.linkAltHover", false, true)}
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
            }

            [aria-current="page"] {
                color: ${getColor("text.accent")};
                font-weight: ${x => x.theme.design.typography.weight.base};
            }
        `,
        /* Store Custom Code - End */
    },
};

export default breadcrumbs;
